.ColumnController182584914__root {
  display: flex;
  flex-direction: column;
  padding-bottom: 38px;
  width: 100%;
}

.ColumnController182584914__sliderContainer {
  width: 100%;
  display: flex;
  -st-states: disabled;
}

.ColumnController182584914__sliderContainer.ColumnController182584914--disabled * {
  cursor: not-allowed;
  border-color: #e0e0e0;
}

.ColumnController182584914__actionsContainer {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
  width: 100%;
}

.ColumnController182584914__actionsContainer > *:last-child {
  margin-right: 0px;
}

.ColumnController182584914__actionsContainer > * {
  margin-right: 6px;
  border-radius: 50%;
}

.ColumnController182584914__blockWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 10;
}

.ColumnController182584914__blockWrapper:not(:last-child) {
  margin-right: 15px;
}

.ColumnController182584914__placeholder {
  height: 30px;
  position: relative;
  margin-right: 16px;
  background-color: #f7f8f8;
  border-radius: 3px;
  z-index: 0;
}

.ColumnController182584914__block {
  -st-states: disabled, allowReorder, selected, allowActions;
  width: 100%;
  height: 30px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #d6e6fe;
  align-items: center;
  border-radius: 3px;
  user-select: none;
  container-type: inline-size;
}

.ColumnController182584914__block.ColumnController182584914--allowActions:not(.ColumnController182584914--selected):hover {
  background-color: #80b1ff;
  cursor: pointer;
}

.ColumnController182584914__block.ColumnController182584914--allowReorder:hover {
  background-color: #80b1ff;
}

.ColumnController182584914__block.ColumnController182584914--allowReorder:hover:not(.ColumnController182584914--disabled) > span,
.ColumnController182584914__block.ColumnController182584914--allowActions:not(.ColumnController182584914--selected):hover > span {
  color: #fff;
}

.ColumnController182584914__block.ColumnController182584914--disabled {
  background-color: #e0e0e0 !important;
  cursor: not-allowed;
}

.ColumnController182584914__block.ColumnController182584914--selected {
  background-color: #116dff;
}

.ColumnController182584914__draggedItem {
  -st-states: isDragging;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #116dff;
  border-radius: 3px;
  height: 30px;
  transform: translateY(-3px);
}

.ColumnController182584914__draggedItem.ColumnController182584914--isDragging {
  transform: translateY(0);
  box-shadow: 0px 2px 17px 0px rgba(19, 55, 82, 0.11);
}

.ColumnController182584914__draggedItemInputWrapper {
  display: flex;
  justify-content: center;
}

.ColumnController182584914__draggedItemInputWrapper .ColumnController182584914__inputClass {
  position: unset !important;
  margin-top: 6px;
  box-shadow: 0px 2px 17px 0px rgba(19, 55, 82, 0.11);

}

.ColumnController182584914__handleContainer {
  position: relative;
}

.ColumnController182584914__inputClass {
  width: 40px !important;
  margin-top: 12px;
  position: absolute;
  top: calc(100% - 6px);
  padding: 3px 6px !important;
}

.ColumnController182584914__inputClass input {
  font-size: 10px !important;
  text-overflow: unset !important;
}

.ColumnController182584914__dragHandle {
  -st-states: disabled, isDragging, isActive;
  position: absolute;
  cursor: col-resize;
  left: calc(100% - 14px);
  height: 30px;
  width: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
}

.ColumnController182584914__dragHandle.ColumnController182584914--isActive {
  background-color: #d6e6fe;
}

.ColumnController182584914__dragHandle:not(.ColumnController182584914--disabled):hover {
  background-color: #d6e6fe;
}

.ColumnController182584914__dragHandle.ColumnController182584914--isDragging {
  cursor: grabbing;
}

.ColumnController182584914__dragHandle.ColumnController182584914--isDragging > svg {
  width: 100%;
}

.ColumnController182584914__dragHandle.ColumnController182584914--disabled > svg {
  fill: #898989;
}

.ColumnController182584914__columnNumber {
    -st-states: hidden;
    /* this has JS fallback in case browser doesn't support @container */
   @container (max-width: 12px) {
    visibility: hidden;
  }
}

.ColumnController182584914__columnNumber.ColumnController182584914--hidden {
   display: none;
}

/* st-namespace-reference="../../../../src/atoms/ColumnController/ColumnController.st.css" */